import React from "react";

export default function VehiclePrice({price, currencyExchangeRate, className=''}) {

    // Russian locale formatter (uses narrow no-break space as thousands separator)
    const ruFormatter = new Intl.NumberFormat("ru-RU");

    // pick salePrice if present, otherwise fullPrice
    const value = price.salePrice ?? price.fullPrice;
    const full  = price.fullPrice;

    // helper to round & format
    const fmt = n => ruFormatter.format(Math.round(n));

    return (
        <div className={`main-price ${className}`}>
            <strong>{fmt(value * currencyExchangeRate)} руб.</strong>
            <span className="ms-2">${ruFormatter.format(value)}</span>
            {price.salePrice && (
                <>
                    <br />
                    <strike className="pl-2">
                        <strong>{fmt(full * currencyExchangeRate)} руб.</strong>
                        <span className="ms-2">~</span>${ruFormatter.format(full)}
                    </strike>
                </>
            )}
        </div>
    );
}